/**
 * 쉽다 AB테스트에 사용중인 browser storage key 리스트
 */
const LOCAL_STORAGE_KEY_LIST_FOR_SHIPDA_AB_TEST: string[] = [];

export { LOCAL_STORAGE_KEY_LIST_FOR_SHIPDA_AB_TEST };
